"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _VersioningConfiguration_1 = require("./_VersioningConfiguration");
exports.PutBucketVersioningInput = {
    type: "structure",
    required: ["Bucket", "VersioningConfiguration"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        ContentMD5: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "Content-MD5"
        },
        MFA: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-mfa"
        },
        VersioningConfiguration: {
            shape: _VersioningConfiguration_1._VersioningConfiguration,
            locationName: "VersioningConfiguration",
            xmlNamespace: {
                uri: "http://s3.amazonaws.com/doc/2006-03-01/"
            }
        }
    },
    payload: "VersioningConfiguration"
};
//# sourceMappingURL=PutBucketVersioningInput.js.map